<template>
  <div class="container">
    <div class="my-5 py-5 mx-1 mx-md-0">
      <h1 class="mb-3">Who Am I?</h1>
      <p>My name is 
        <a class="text-primary" href="https://vishwasracharya.github.io" target="_blank" rel="noopener noreferrer">Vishwas Acharya</a> 
        and am a learner 🎓 & a hustler 😎, presently pursuing my Bachelors in
        Information Technology Engineering from Sardar Patel College of
        Engineering, which is located near Vallabh Vidhyanagar where I live, I
        moved to this city when I was in 10th class before that I used to live
        in Khambhat. Also working remotely as a Jr Frontend Developer intern at
        <a class="text-primary" href="https://futureblink.com/">@futureblink</a>,
      </p>
      <p> I was a kinda introverted guy so to overcome my shyness and as a side hustle I make
        <a class="text-primary" href="https://youtube.com/c/VishwasAcharya">Youtube</a>
        videos,
        <a class="text-primary" href="https://open.spotify.com/show/7DQt4atsshjsEG0Am49lHr?si=ii3DcV4JQT2CxOJWWidZKg&utm_source=copy-link">Podcasts</a>
        🎙 and I have a liking towards Photography also, so sharing that through my
        <a class="text-primary" href="https://instagram.com/vishwasracharya">Instagram</a>.
      </p>
      <p> And when I feel low 🥱 or in a zone to do nothing then I listen to songs
        🎶 and dance on them, just to get myself back on track.
      </p>
      <div class="m-0 p-0">
      <a class="ms-0 mx-1 p-2 tab fa-brands fa-twitter" href="https://www.twitter.com/vishwasracharya" title="Vishwas Acharya Twitter Profile" target="_blank"></a>
      <a class="mx-1 p-2 tab fa-brands fa-instagram" href="https://www.instagram.com/vishwasracharya" title="Vishwas Acharya Instagram Profile" target="_blank"></a>
      <a class="mx-1 p-2 tab fa-brands fa-blogger-b" href="https://vishwasacharya.blogspot.com" title="Vishwas Acharya Blogger Profile" target="_blank"></a>
      <a class="mx-1 p-2 tab fa-brands fa-linkedin" href="https://www.tabedin.com/in/vishwasracharya" title="Vishwas Acharya Linkedin Profile" target="_blank"></a>
      <a class="mx-1 p-2 tab fa-brands fa-facebook" href="https://www.facebook.com/vishwasracharya" title="Vishwas Acharya Facebook Profile" target="_blank"></a>
      <a class="mx-1 p-2 tab fa-brands fa-github" href="https://www.github.com/vishwasracharya" title="Vishwas Acharya GitHub Profile" target="_blank"></a>
      <a class="mx-1 p-2 tab fa-brands fa-snapchat" href="https://www.snapchat.com/add/vishwasracharya" title="Vishwas Acharya SnapChat Profile" target="_blank"></a>
      <a class="mx-1 p-2 tab fa-brands fa-telegram" href="https://t.me/vishwasracharya" title="Vishwas Acharya Telegram Profile" target="_blank"></a>
    </div>
    </div>
  </div>
</template>
